// extracted by mini-css-extract-plugin
export default {"button":"LoadFile_button__zKqXB"};